import { render } from "./SearchLocalsList.vue?vue&type=template&id=419eaf08&ts=true"
import script from "./SearchLocalsList.vue?vue&type=script&lang=ts"
export * from "./SearchLocalsList.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__